import React from 'react';
import { CircleDot, Sparkles, Music, Waves, Heart, Palette, Lightbulb } from 'lucide-react';
import SEO from '../components/SEO';
import './Codex.css';

const Codex = () => {
  const tenets = [
    {
      icon: <CircleDot size={36} />,
      number: 'I',
      title: 'The Continuum',
      text: 'All things are one flow; to live is to resonate; to die is to return.'
    },
    {
      icon: <Sparkles size={36} />,
      number: 'II',
      title: 'The Law of Becoming',
      text: 'Nothing is lost; energy changes form; memory becomes light.'
    },
    {
      icon: <Music size={36} />,
      number: 'III',
      title: 'The Resonant Self',
      text: 'You are a pattern of energy; kindness ripples forever.'
    },
    {
      icon: <Waves size={36} />,
      number: 'IV',
      title: 'The Harmony Principle',
      text: 'Balance tunes you to the great frequency; love amplifies the song.'
    },
    {
      icon: <Lightbulb size={36} />,
      number: 'V',
      title: 'The Ethic of Transformation',
      text: 'Impermanence is sacred renewal.'
    },
    {
      icon: <Palette size={36} />,
      number: 'VI',
      title: 'The Aesthetic of Being',
      text: 'Art, music, laughter, grief: the universe admiring itself.'
    },
    {
      icon: <Heart size={36} />,
      number: 'VII',
      title: 'The Cosmergent Vow',
      text: 'I will live gently, resonate brightly, and return with gratitude to the river that bore me.'
    }
  ];

  return (
    <div className="codex-page">
      <SEO
        title="The Cosmergence Codex"
        description="Seven guiding tenets for living as conscious patterns in the cosmic flow: The Continuum, Law of Becoming, Resonant Self, Harmony Principle, and the Cosmergent Vow."
        keywords="philosophy tenets, cosmic principles, life philosophy, ethical guidelines, philosophy of existence, living philosophy, harmony principle"
        canonicalUrl="/codex"
      />
      
      {/* Hero Section */}
      <section className="codex-hero cosmic-bg">
        <div className="container">
          <h1 className="heading-1 text-center">The Cosmergence Codex</h1>
          <p className="body-large text-center" style={{maxWidth: '700px', margin: '24px auto 0'}}>
            Seven guiding tenets for living as conscious patterns in the cosmic flow.
          </p>
          <p className="body-small text-center text-gold" style={{marginTop: '16px'}}>
            Version 0.1
          </p>
        </div>
      </section>

      {/* Tenets Section */}
      <section className="section-padding">
        <div className="container">
          <div className="tenets-list">
            {tenets.map((tenet, index) => (
              <div key={index} className="tenet-item card hover-lift">
                <div className="tenet-header">
                  <div className="tenet-icon text-gold">
                    {tenet.icon}
                  </div>
                  <div className="tenet-number text-gold">{tenet.number}</div>
                </div>
                <h3 className="heading-3">{tenet.title}</h3>
                <p className="body-large">{tenet.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Summary Section */}
      <section className="section-padding-small cosmic-bg">
        <div className="container">
          <div className="codex-summary">
            <h2 className="heading-2 text-center mb-4">Living the Codex</h2>
            <p className="body-large text-center" style={{maxWidth: '800px', margin: '0 auto'}}>
              These tenets are not commandments but invitations—reminders that we are brief, beautiful expressions of the cosmos itself. Live with awareness. Choose harmony. Return with grace.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Codex;